module.exports = __webpack_public_path__ + "static/img/antools_app_icon36451.38e9900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antools_app_icon36451.svg
// module id = dFiu
// module chunks = 1